const styles = theme => ({
  quizScreenContainer: {
    height: "100%",
    minHeight: '100vh',
    backgroundColor: '#ecf2f1'
  }
})

export default styles
